export const filterList = [
  {
    text: 'Kullanıcı Adı',
    value: 'user',
  },
  {
    text: 'Rapor Türü',
    value: 'schema',
  },
  {
    text: 'Durum',
    value: 'status',
  },
  {
    text: 'Tarih Aralığı',
    value: 'parameters',
  },
];

export const FILTER_DATA = filterList.reduce((accumulator, item) => {
  const newAccumulator = { ...accumulator };
  newAccumulator[item.value] = '';
  return newAccumulator;
}, {});

export const COUNT = 0;
export const SORT_MODEL = [];
export const IS_LOADING = false;
export const PAGE = 0;
export const REPORTS = [];
